export default {
  'admin.Home': 'Home',
  'admin.Dashboard': 'Dashboard',
  'admin.You are logged in as a administrator.':
    'You are logged in as a administrator.',
  'admin.ROAR Window': 'ROAR Window',
  'admin.Database': 'Database',
  'admin.Permission': 'Permission',
  'admin.Create New Period': 'Create New Period',
  'admin.New Period': 'New Period',
  'admin.Edit Period': 'Edit Period',
  'admin.Period Name': 'Period Name',
  'admin.Please Input': 'Please Input',
  'admin.Period Type': 'Period Type',
  'admin.Online': 'Online',
  'admin.Offline': 'Offline',
  'admin.Employee Application Period': 'Employee Application Period',
  'admin.The entire timeline for Project ROAR, from project start day to the day it ends (several days after Panel Result Submission end day).':
    'The entire timeline for Project ROAR, from project start day to the day it ends (several days after Panel Result Submission end day).',
  'admin.Edit': 'Edit',
  'admin.Publish Manager': 'Publish Manager',
  'admin.Publish Employee': 'Publish Employee',
  'admin.Delete': 'Delete',
  'admin.Review Manager Assessment Period': 'Review Manager Assessment Period',
  'admin.HRBP Assessment Period': 'HRBP Assessment Period',
  'admin.Panel Result Upload Period': 'Panel Result Upload Period',
  'admin.Action': 'Action',
  'admin.Publish Result': 'Publish Result',
  'admin.HRBP Review Period': 'HRBP Review Period',
  'admin.Panel Result Submission Period': 'Panel Result Submission Period',
  'admin.From one day after HRBP Review end day to the last day that requires HRBP to upload panel result after getting global confirmation.':
    'From one day after HRBP Review end day to the last day that requires HRBP to upload panel result after getting global confirmation.',
  'admin.From the start day to the last day that requires the employee to submit application.':
    'From the start day to the last day that requires the employee to submit application.',
  'admin.From the start day to the last day that requires the manager to submit assessment (several days after “Employee Application” end day).':
    'From the start day to the last day that requires the manager to submit assessment (several days after “Employee Application” end day).',
  'admin.From the start day to the last day that allows HRBP to reopen assessment (several days after “Manager Assessment” end day). Application approval status will be published after HRBP Review end day.':
    'From the start day to the last day that allows HRBP to reopen assessment (several days after “Manager Assessment” end day). Application approval status will be published after HRBP Review end day.',
  'admin.Select date': 'Select date',
  'admin.Cancel': 'Cancel',
  'admin.Save': 'Save',
  'admin.Are you sure you want to publish result?':
    'Are you sure you want to publish result?',
  'admin.Yes': 'Yes',
  'admin.No': 'No',
  'admin.Deleted successfully': 'Deleted successfully',
  'admin.Published successfully': 'Published successfully',
  'admin.Employee': 'Employee',
  'admin.Upload Employee List': 'Upload Employee List',
  'admin.Download Employee List': 'Download Employee List',
  'admin.View History': 'View History',
  'admin.Employee / Review Manager': 'Employee / Review Manager',
  'admin.Employee / Review Manager / Brand':
    'Employee / Review Manager / Brand',
  'admin.Employees': 'Employees',
  'admin.Total': 'Total',
  'admin.Transfer': 'Transfer',
  'admin.Career Guide': 'Career Guide',
  'admin.Review Manager Permission': 'Review Manager Permission',
  'admin.Review Manager': 'Review Manager',
  'admin.Review Managers': 'Review Manager',
  'admin.HRBP': 'HRBP',
  "admin.Please make sure there is at least one ROAR window and it's before apply start time":
    "Please make sure there is at least one ROAR window and it's before apply start time",
  'admin.Reopen Both': 'Reopen Both',
  'admin.Reopen Review Manager': 'Reopen Review Manager',
  'admin.View Comments': 'View Comments',
  'admin.Time of Action': 'Time of Action',
  'admin.Close': 'Close',
  'admin.User': 'User',
  'admin.File Name': 'File Name',
  'admin.Lion ID': 'Lion ID',
  'admin.Name': 'Name',
  'admin.Current Role': 'Current Role',
  'admin.Target Role': 'Target Role',
  'admin.Current Brand': 'Current Brand',
  'admin.Target Brand': 'Target Brand',
  'admin.Location': 'Location',
  'admin.Status': 'Status',
  'admin.Assessment Result': 'Assessment Result',
  'admin.Back': 'Back',
  'admin.Learning': 'Learning',
  'admin.Mandatory': 'Mandatory',
  'admin.No Comments': 'No Comments',
  'admin.Learning Link': 'Learning Link',
  'admin.Learning Record': 'Learning Record',
  'admin.Upload Career Guide': 'Upload Career Guide',
  'admin.Upload Guide': 'Upload Guide',
  'admin.File Name / Creator': 'File Name / Creator',
  'admin.Files': 'Files',
  'admin.File': 'File',
  'admin.Creator': 'Creator',
  'admin.Upload Time': 'Upload Time',
  'admin.Download': 'Download',
  'admin.Rename': 'Rename',
  'admin.Download EN Template': 'Download EN Template',
  'admin.Upload Learning Link': 'Upload Learning Link',
  'admin.Upload Learning Record': 'Upload Learning Record',
  'admin.Rename File': 'Rename File',
  'admin.Please download the template for uploading':
    'Please download the template for uploading',
  'admin.Upload': 'Upload',
  'admin.Upload EN File': 'Upload EN File',
  'admin.Select the file (System will renew the items in the list from the uploaded document)':
    'Select the file (System will renew the items in the list from the uploaded document)',
  'admin.Add New Employee': 'Add New Employee',
  'admin.Download Employee Application Records':
    'Download Employee Application Records',
  'admin.Employee Permission': 'Employee Permission',
  'admin.Edit Employee': 'Edit Employee',
  'admin.Employee LLID': 'Employee LLID ',
  'admin.Employee CS ID': 'Employee CS ID',
  'admin.Employee English Name': 'Employee English Name',
  'admin.Employee Email Address': 'Employee Email Address',
  'admin.Employee Title': 'Employee Title',
  'admin.Level1': 'Level1',
  'admin.SubLevel': 'SubLevel',
  'admin.Level2': 'Level2',
  'admin.Level3': 'Level3',
  'admin.Job Grading': 'Job Grading',
  'admin.Please Select': 'Please Select',
  'admin.Add': 'Add',
  'admin.Location of Employee': 'Location of Employee',
  'admin.HFM Code': 'HFM Code',
  'admin.Department/Client': 'Department/Client',
  'admin.Parent Function': 'Parent Function',
  'admin.Child Function': 'Child Function',
  'admin.Join Date': 'Join Date',
  'admin.Review Manager Name(EN)': 'Review Manager Name(EN)',
  'admin.LLID of Review Manager': 'LLID of Review Manager',
  'admin.LLID of HRBP': 'LLID of HRBP',
  'admin.Review Manager Email Address': 'Review Manager Email Address',
  'admin.Review Manager Title': 'Review Manager Title',
  'admin.Brand of Review Manager': 'Brand of Review Manager',
  'admin.HRBP Name (EN)': 'HRBP Name (EN)',
  'admin.HRBP Email Address': 'HRBP Email Address',
  'admin.Download employee application record':
    'Download employee application record',
  'admin.Download Current Record': 'Download Current Record',
  'admin.Download all Record': 'Download all Record',
  'admin.Title': 'Title',
  'admin.The application is waiting for review manager to review.':
    'The application is waiting for review manager to review.',
  'admin.The panel review application has been approved.':
    'The panel review application has been approved.',
  'admin.The panel review application is not approved.':
    'The panel review application is not approved.',
  "admin.The talent's application is reopened.":
    "The talent's application is reopened.",
  'admin.Role Change': 'Role Change',
  'admin.Change': 'Change',
  'admin.Dual Role': 'Dual Role',
  'admin.Cancel Account': 'Cancel Account',
  'admin.Are you sure you want to cancel the current account?':
    'Are you sure you want to cancel the current account?',
  'admin.Add New Review Manager': 'Add New Review Manager',
  'admin.HRBPs': 'HRBPs',
  'admin.HRBP Permission': 'HRBP Permission',
  'admin.Add New HRBP': 'Add New HRBP',
  'admin.Edit HRBP': 'Edit HRBP',
  'admin.If you leave before saving, your changes will be lost':
    'If you leave before saving, your changes will be lost',
  'admin.OK': 'OK',
  'admin.Ok': 'Ok',
  'admin.Reset': 'Reset',
  'admin.All': 'All',
  'admin.Reopen': 'Reopen',
  'admin.Are you sure you want to reopen review manager’s assessment and employee’s application?':
    'Are you sure you want to reopen review manager’s assessment and employee’s application?',
  'admin.Are you sure you want to reopen review manager’s assessment?':
    'Are you sure you want to reopen review manager’s assessment?',
  'admin.Delete File': 'Delete File',
  'admin.Are you sure you want to delete the file?':
    'Are you sure you want to delete the file?',
  'admin.Found the duplicated data. Do you want to replace?':
    'Found the duplicated data. Do you want to replace?',
  'admin.Clear All': 'Clear All',
  'admin.Apply': 'Apply',
  'admin.Download Template': 'Download Template',
  'admin.Upload File': 'Upload File',
  'admin.Select ROAR Window': 'Select ROAR Window',
  'admin.You have successfully uploaded the Employee List.':
    'You have successfully uploaded the Employee List.',
  'admin.You did not upload the Employee List successfully':
    'You did not upload the Employee List successfully',
  'admin.Incorrect Excel template type': 'Incorrect Excel template type',
  'admin.Review Manager can now re-assess.':
    'Review Manager can now re-assess.',
  'admin.Review manager and employee can now re-assess.':
    'Review manager and employee can now re-assess.',
  'admin.Selected': 'Selected',
  'admin.items': 'items',
  'admin.Panel Result': 'Panel Result',
  'admin.Panel Comments': 'Panel Comments',
  'admin.Role': 'Role',
  'admin.Please enter the correct LionID': 'Please enter the correct LionID',
  'admin.Update Result': 'Edit Result',
  'admin.Update Employee Result': 'Edit Result',
  'admin.Please select the panel result': 'Please select the panel result',
  'admin.You have successfully updated the employee result': 'You have successfully updated the employee result',
  'admin.Failed to update employee result': 'Failed to update employee result',
  'admin.Review Manager Comments': 'Review Manager Comments',
  'admin.Employee Comments': 'Employee Comments',
  'admin.Result Comments': 'Comments',
  'admin.No comments': 'No comments',
  'admin.Batch Upload Result': 'Result Mass Upload',
  'admin.Upload Result Excel': 'Upload Result Excel',
  'admin.Download Result Template': 'Download Result Template',
  'admin.Upload Result File': 'Upload Result File',
  'admin.Select the result file (Excel)': 'Select the result file (Excel)',
  'admin.Preview Data': 'Preview Data',
  'admin.Result Value': 'Result Value',
  'admin.Total Records': 'Total Records',
  'admin.Confirm Upload': 'Confirm Upload',
  'admin.Invalid file format': 'Invalid file format',
  'admin.Please upload Excel file': 'Please upload Excel file',
  'admin.Batch update successful': 'Batch update successful',
  'admin.Batch update failed': 'Batch update failed',
  'admin.No valid data in file': 'No valid data in file',
  'admin.You have successfully transferred the selected employees to the new manager/HRBP':
    'You have successfully transferred the selected employees to the new manager/HRBP',
  'admin.You have successfully added a new hrbp':
    'You have successfully added a new hrbp',
  'admin.You have successfully updated hrbp information':
    'You have successfully updated hrbp information',
  'admin.Renamed successfully.': 'Renamed successfully.',
  'admin.Updated successfully': 'Updated successfully',
  'admin.You have successfully updated review manager information.':
    'You have successfully updated review manager information.',
  'admin.You have successfully added a new review manager.':
    'You have successfully added a new review manager.',
  'admin.Edit Review Manager': 'Edit Review Manager',
  'admin.Incorrect mailbox format': 'Incorrect mailbox format',
  'admin.Click to sort descending': 'Click to sort descending',
  'admin.Click to sort ascending': 'Click to sort ascending',
  'admin.Click to cancel sorting': 'Click to cancel sorting',
  'admin.Are you sure to add employee identity rights for this manager?':
    'Are you sure to add employee identity rights for this manager?',
  'admin.Are you sure to add manager identity rights for this employee?':
    'Are you sure to add manager identity rights for this employee?',
  'admin.Dual': 'Dual',
  'admin.You have successfully added manager privileges for this employee':
    'You have successfully added manager privileges for this employee',
  'admin.You have successfully added employee privileges for this manager':
    'You have successfully added employee privileges for this manager',
  'admin.Period type cannot be changed when status is active':
    'Period type cannot be changed when status is active',
}
